"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleSocPayloadToFormDataHandler = scheduleSocPayloadToFormDataHandler;
function scheduleSocPayloadToFormDataHandler(data) {
    return {
        futureAppointment: {
            visitDate: data.form.visitDate,
            visitStartTime: data.form.visitStartTime,
            visitEndTime: data.form.visitEndTime,
        },
        notes: data.form.notes || "",
    };
}
